import generateObjectId from "./generateObjectId";

const createBlock = (data, x, y, _x, _y) => {
    var { tree : block, server : blockServer } = data;
    const objectId = generateObjectId();
    block.object_id = objectId;
    blockServer.object_id = objectId;
    block.x = Math.round(- x) + _x;
    block.y = Math.round(- y) + _y;

    if(block.id) {
        delete block.id
    }

    const children = [];
    if(block.children != undefined) {
        for(var i = 0; i < block.children.length; i++) {
            block.children[i].parent_block_id = objectId
            block.children[i].object_id = generateObjectId(i, true);
            block.children[i].index = i;
            if(block.children[i].id) {
                delete block.children[i].id;
            }
            let child = block.children[i];
            children.push(child);
        }

        children.sort((child1, child2) => (child1.object_id == child2.object_id ? 0 : (child1.object_id > child2.object_id ? 1 : -1)))
    }

    blockServer = {...block, ...blockServer}
    if(blockServer.data) {
        delete blockServer.data
    }

    return { block, blockServer, children }
}

export default createBlock